import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { OrgEventAutomationRule } from 'hooks/orgEvents/orgEventAutomationHooks';
import { RuleEditorSteps } from './RuleEditorSteps';

type AutomationRuleEditorDialogProps = {
  rule: OrgEventAutomationRule | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function AutomationRuleEditorDialog({
  rule,
  open,
  onOpenChange,
}: AutomationRuleEditorDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="dark tw:max-h-[85vh] tw:overflow-y-auto tw:bg-background tw:text-foreground sm:tw:max-w-3xl">
        <DialogHeader>
          <DialogTitle>{rule?.name ?? 'Automation rule'}</DialogTitle>
        </DialogHeader>
        {rule ? (
          <RuleEditorSteps rule={rule} onClose={() => onOpenChange(false)} />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
